function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#474747"
}, React.createElement("path", {
  d: "m25.77 247.52v16.918c101.55 169.26 358.92 169.26 460.47 0v-16.918c-101.55-169.2-358.93-169.2-460.47 0zm230.23 118.33c-60.754 0-109.88-49.199-109.88-109.87 0-60.691 49.121-109.85 109.88-109.85 60.617 0 109.86 49.152 109.86 109.85 0.007812 60.676-49.242 109.87-109.86 109.87z"
}), React.createElement("path", {
  d: "m256 205.23c-28.047 0-50.797 22.641-50.797 50.746 0 28.047 22.754 50.797 50.797 50.797 28.031 0 50.734-22.75 50.734-50.797 0-28.105-22.695-50.746-50.734-50.746z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "512pt",
    height: "512pt",
    padding: "5px",
    version: 1.1,
    viewBox: "0 0 512 512"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/icon-private-opp.3c5bd6fc.svg";
export { SvgComponent as ReactComponent };